export const TOAST_TYPES = {
  ALERT: "alert",
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
};

export const TOAST_OFFSET = 4;

export const DEFAULT_AUTODISMISS_TIME = 2500; //in milliseconds
